var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.975 6.178a.6.6 0 11.848.849L16.848 16l8.975 8.974a.6.6 0 01-.848.848l-8.976-8.973-8.975 8.973a.6.6 0 11-.848-.848L15.15 16 6.176 7.027a.6.6 0 11.848-.85L16 15.153l8.975-8.974z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNC45NzQ3IDYuMTc3OUMyNS4yMDkgNS45NDM2IDI1LjU4ODkgNS45NDM2MyAyNS44MjMyIDYuMTc3OTdDMjYuMDU3NSA2LjQxMjMgMjYuMDU3NSA2Ljc5MjIgMjUuODIzMSA3LjAyNjVMMTYuODQ4MSAxNkwyNS44MjMzIDI0Ljk3MzdDMjYuMDU3NiAyNS4yMDggMjYuMDU3NiAyNS41ODc5IDI1LjgyMzMgMjUuODIyM0MyNS41ODkgMjYuMDU2NiAyNS4yMDkxIDI2LjA1NjYgMjQuOTc0OCAyNS44MjIzTDE1Ljk5OTUgMTYuODQ4NUw3LjAyNDIzIDI1LjgyMjNDNi43ODk5IDI2LjA1NjYgNi40MSAyNi4wNTY2IDYuMTc1NyAyNS44MjIzQzUuOTQxNDEgMjUuNTg3OSA1Ljk0MTQ0IDI1LjIwOCA2LjE3NTc3IDI0Ljk3MzdMMTUuMTUwOSAxNkw2LjE3NTkxIDcuMDI2NUM1Ljk0MTU3IDYuNzkyMiA1Ljk0MTU0IDYuNDEyMyA2LjE3NTg0IDYuMTc3OTdDNi40MTAxMyA1Ljk0MzYzIDYuNzkwMDMgNS45NDM2IDcuMDI0MzYgNi4xNzc5TDE1Ljk5OTUgMTUuMTUxNkwyNC45NzQ3IDYuMTc3OVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIconClose as ReactComponent };